import { Button } from '@/components/ui/button';
import { ScrollReveal } from '@/components/effects/ScrollReveal';
import { ArrowRight } from 'lucide-react';

export const CTABand = () => {
  return (
    <section
      id="cta"
      data-testid="cta-band"
      className="relative"
      style={{
        background:
          'linear-gradient(135deg, rgba(8,4,16,1) 0%, rgba(20,8,40,1) 50%, rgba(8,4,16,1) 100%)',
        borderTop: '1px solid rgba(139,92,246,0.2)',
        borderBottom: '1px solid rgba(139,92,246,0.2)',
      }}
    >
      {/* Radial purple glow */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            'radial-gradient(ellipse 80% 60% at 50% 50%, rgba(139,92,246,0.12) 0%, transparent 70%)',
        }}
      />

      <div
        className="relative max-w-[800px] mx-auto text-center"
        style={{ padding: 'clamp(2.5rem, 5vw, 3rem) clamp(1.5rem, 4vw, 2rem)' }}
      >
        <ScrollReveal>
          {/* Pill badge eyebrow */}
          <div
            data-testid="cta-eyebrow-pill"
            className="inline-flex items-center"
            style={{
              background: 'rgba(139,92,246,0.15)',
              border: '1px solid rgba(139,92,246,0.3)',
              borderRadius: '100px',
              padding: '0.35rem 1rem',
              marginBottom: '1.05rem',
            }}
          >
            <span
              className="font-mono uppercase"
              style={{
                fontSize: '0.7rem',
                letterSpacing: '0.12em',
                color: 'var(--a)',
              }}
            >
              Start protecting your business today
            </span>
          </div>

          {/* Two-line headline */}
          <h2
            data-testid="cta-headline"
            className="font-display font-extrabold tracking-[-0.03em]"
            style={{
              fontSize: 'clamp(1.6rem, 3vw, 2.2rem)',
              color: 'var(--white)',
              lineHeight: 1.1,
              marginBottom: '1.05rem',
            }}
          >
            Ready to Secure
            <br />
            Your Business?
          </h2>

          {/* Sub text */}
          <p
            className="font-body font-light mx-auto"
            style={{
              fontSize: '0.9rem',
              color: 'var(--tm)',
              lineHeight: 1.7,
              maxWidth: '520px',
              marginBottom: '1.75rem',
            }}
          >
            Join hundreds of London businesses already protected by Acodia Watch.
            Set up takes minutes. Your first scan runs the moment your domain is
            verified.
          </p>

          {/* Trust stats row */}
          <div
            data-testid="cta-trust-stats"
            className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 font-mono"
            style={{
              fontSize: '0.85rem',
              marginBottom: '1.75rem',
              letterSpacing: '0.02em',
            }}
          >
            <span style={{ color: 'var(--a)' }}>400+ businesses protected</span>
            <span aria-hidden="true" style={{ color: 'var(--b1)' }}>·</span>
            <span style={{ color: 'var(--a)' }}>From £49/month</span>
            <span aria-hidden="true" style={{ color: 'var(--b1)' }}>·</span>
            <span style={{ color: 'var(--ok)' }}>7-day free trial</span>
          </div>

          {/* Primary CTA */}
          <a
            href="/auth"
            data-testid="cta-primary-button"
            className="btn-shimmer inline-flex items-center justify-center font-body font-medium transition-all duration-200"
            style={{
              background: 'var(--a)',
              color: 'var(--white)',
              padding: '1rem 2.5rem',
              borderRadius: '8px',
              fontSize: '1rem',
              boxShadow: '0 0 40px rgba(139,92,246,0.35)',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = 'var(--violet)';
              e.currentTarget.style.boxShadow = '0 0 60px rgba(139,92,246,0.55)';
              e.currentTarget.style.transform = 'translateY(-2px)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = 'var(--a)';
              e.currentTarget.style.boxShadow = '0 0 40px rgba(139,92,246,0.35)';
              e.currentTarget.style.transform = 'translateY(0)';
            }}
          >
            Start Free Trial
            <ArrowRight size={18} className="ml-2" />
          </a>
        </ScrollReveal>
      </div>
    </section>
  );
};
